<template>
	<div id="wrapper">
		<SidebarView :loan="true" :repayLoan="true" :loanVisible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />

				<div class="mx-3">
					<div class="row">
						<div class="col-lg-12">
							<div class="card card-shape home-box">
								<div class="card-header">
									<div
										class="d-flex justify-content-between align-items-center">
										<div>
											<h6 class="m-0 fw-bold text-green">
												Loan Repayments
											</h6>
										</div>
									</div>
								</div>
								<div
									class="card-body py-3 default_bg"
									style="
										border-bottom: 1px solid
											rgb(1, 134, 115);
									">
									<div
										class="home-box border border-success p-3 bg-white">
										<repayment-filter
											:form="form"
											:filterTable="
												filterTable
											"></repayment-filter>
									</div>
								</div>
								<div class="card-body p-0">
									<div class="table_text_size">
										<b-table
											striped
											bordered
											responsive
											id="repayment-table"
											:busy.sync="isBusy"
											:items="rows"
											:fields="fields"
											:tbody-tr-class="rowClass"
											show-empty>
											<template #empty="scope">
												<h4
													class="text-center small mt-3">
													{{ scope.emptyText }}
												</h4>
											</template>
											<template #table-busy>
												<div
													class="text-center text-danger my-2">
													<b-spinner
														class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<!-- <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template> -->
											<!-- A custom formatted column -->
											<template #cell(customer)="data">
												<div>
													{{
														data.item.customer
															?.first_name
													}}
													{{
														data.item.customer
															?.last_name
													}}
												</div>
											</template>
											<template
												#cell(trans_amount)="data">
												<div>
													{{
														displayNumber(
															data.item
																.trans_amount
														)
													}}
												</div>
											</template>
											<template #cell(interest)="data">
												<div>
													{{
														displayNumber(
															data.item.interest
														)
													}}
												</div>
											</template>
											<template #cell(principal)="data">
												<div>
													{{
														displayNumber(
															data.item.principal
														)
													}}
												</div>
											</template>
											<template
												#cell(trans_status)="data">
												<span
													:class="
														statusBadge(
															data.item
																.trans_status
														)
													"
													>{{
														data.item.trans_status
													}}</span
												>
											</template>
											<template #cell(actions)="data">
												<div class="d-flex">
													<div
														title="Print"
														class="dropdown no-arrow">
														<a
															title="Print"
															class="btn btn-sm akkurate-gray-btn text-white dropdown-toggle"
															id="dropdownMenu"
															data-bs-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false">
															<span
																class="akkurate-small">
																<font-awesome-icon
																	:icon="[
																		'fas',
																		'book',
																	]" />
															</span>
														</a>
														<div
															class="dropdown-menu shadow animated--fade-in"
															aria-labelledby="dropdownMenu">
															<div
																class="dropdown-header">
																Printout
															</div>
															<button
																v-if="
																	data.item
																		.trans_status ==
																	'COMPLETED'
																"
																class="dropdown-item"
																@click="
																	printReceipt(
																		data.item
																	)
																">
																Print receipts
															</button>
															<button
																@click="
																	chequePrintout(
																		data.item
																	)
																"
																v-if="
																	data.item
																		.transaction_mode ==
																		'Cheque' &&
																	data.item
																		.transaction_type ==
																		'Withdrawal'
																"
																class="dropdown-item">
																Cheque print
															</button>
															<button
																@click="
																	chequeTemplate(
																		data.item
																	)
																"
																v-if="
																	data.item
																		.transaction_mode ==
																		'Cheque' &&
																	data.item
																		.transaction_type ==
																		'Withdrawal'
																"
																class="dropdown-item">
																Cheque voucher
															</button>
														</div>
													</div>

													<!-- <all-trans-view :key="data.item.id + 'View'" :data="data.item"
                            :transaction="'View'"></all-trans-view> -->

													<a
														v-if="
															data.item
																.is_reversed ==
																0 &&
															data.item
																.trans_status ==
																'COMPLETED'
														"
														title="Reverse"
														class="btn btn-sm akkurate-primary text-white"
														@click="
															reverseTransaction(
																data.item
															)
														">
														<span
															class="akkurate-small"
															><font-awesome-icon
																:icon="[
																	'fas',
																	'backward',
																]"
														/></span>
													</a>

													<a
														v-if="
															data.item
																.trans_status ==
																'PENDING' &&
															data.item
																.transaction_type ==
																'Withdrawal'
														"
														title="Approve"
														class="btn btn-sm akkurate-green-btn text-white"
														@click="
															approveWithdrawal(
																data.item
															)
														">
														<span
															class="akkurate-small">
															<font-awesome-icon
																:icon="[
																	'fas',
																	'check',
																]" />
														</span>
													</a>
												</div>
											</template>
										</b-table>

										<div
											class="d-flex justify-content-between px-3">
											<b-pagination
												class="mt-1"
												@change="navigatePage"
												v-model="currentPage"
												:total-rows="totalRecords"
												:per-page="perPage"
												aria-controls="member-table"></b-pagination>
											<!-- <b-form-select @change="selectPerPage" v-model="per_page_selected" :options="per_page_options"
                        size="sm" class="mt-3"></b-form-select> -->
											<div
												class="col text-end mt-1 akkurate-dark">
												<div>
													{{ currentPage }} -
													{{ perPage }} of
													{{ totalRecords }}
												</div>
												<b-form-group
													label="Per Page"
													label-size="sm"
													class="mb-0">
													<b-form-select
														@change="selectPerPage"
														id="per-page-select"
														v-model="perPage"
														:options="
															per_page_options
														"
														size="sm"></b-form-select>
												</b-form-group>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
            </div>
          </div>
          <div class="card card-shape home-box">
            <div class="card-header py-3 d-flex flex-row align-items-center">
              <h6 class="m-0 fw-bold text-green">All Loan Repayments</h6>
            </div>
            <div class="card-body">
              <div>
                <vue-good-table styleClass="vgt-table bordered striped" mode="remote" ref="allAccountTable"
                  :columns="trans_columns" :rows="rows" :isLoading.sync="isLoading" :totalRows="totalRecords"
                  :pagination-options="{
                    enabled: true,
                    perPage: serverParams.perPage,
                    setCurrentPage: serverParams.page,
                  }" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange">
                  <template slot="table-row" slot-scope="props">
                    <span class="d-flex" v-if="props.column.field == 'action'">
                      <a v-if="
                        props.row.is_reversed == 0 &&
                        props.row.trans_status == 'COMPLETED'
                      " title="Reverse" class="btn btn-sm akkurate-primary text-white"
                        @click="reverseLoanRepaymt(props.row)">
                        <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'backward']" /></span>
                      </a>

                    </span>

                    <span class="d-flex" v-else-if="props.column.field == 'user'">
                      {{ props.row.created_user?.first_name }} {{ props.row.created_user?.surname }}
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div> -->
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"
			><i class="fas fa-angle-up"></i
		></a>

		<!-- <view-transaction-modal
        :showViewTransaction="showViewTransaction"
      ></view-transaction-modal> -->
		<cash-deposit
			ref="showCashDeposit"
			:report_data="report_data"></cash-deposit>
		<cash-withdrawal
			ref="showCashWithdrawal"
			:report_data="report_data"></cash-withdrawal>
		<cheque-deposit
			ref="showChequeDeposit"
			:report_data="report_data"></cheque-deposit>
		<cheque-withdrawal
			ref="showChequeWithdrawal"
			:report_data="report_data"></cheque-withdrawal>
		<momo-deposit
			ref="showMomoDeposit"
			:report_data="report_data"></momo-deposit>
		<momo-withdrawal
			ref="showMomoWithdrawal"
			:report_data="report_data"></momo-withdrawal>
		<direct-debit-deposit
			ref="showDirectDebitDeposit"
			:report_data="report_data"></direct-debit-deposit>
		<direct-debit-withdrawal
			ref="showDirectDebitWithdrawal"
			:report_data="report_data"></direct-debit-withdrawal>
		<cheque-printout
			ref="showChequePrintout"
			:report_data="report_data"></cheque-printout>
		<cheque-template
			ref="showChequeTemplate"
			:report_data="report_data"></cheque-template>
	</div>
</template>
<script>
	import SidebarView from "@/views/main/components/Sidebar.vue";
	import TopbarView from "@/views/main/components/Topbar.vue";
	import Footer from "@/views/main/components/Footer.vue";
	import ApiService from "@/core/services/api.service";
	import ChequeDeposit from "@/views/main/pages/transactions/reports/cheque/ChequeDeposit.vue";
	import ChequeWithdrawal from "@/views/main/pages/transactions/reports/cheque/ChequeWithdrawal.vue";
	import CashDeposit from "@/views/main/pages/transactions/reports/cash/CashDeposit.vue";
	import CashWithdrawal from "@/views/main/pages/transactions/reports/cash/CashWithdrawal.vue";
	import MomoDeposit from "@/views/main/pages/transactions/reports/momo/MomoDeposit.vue";
	import MomoWithdrawal from "@/views/main/pages/transactions/reports/momo/MomoWithdrawal.vue";
	import DirectDebitDeposit from "@/views/main/pages/transactions/reports/direct-debit/DirectDebitDeposit.vue";
	import DirectDebitWithdrawal from "@/views/main/pages/transactions/reports/direct-debit/DirectDebitWithdrawal.vue";
	import ChequePrintout from "../reports/printout/ChequePrintout.vue";
	import ChequeTemplate from "../reports/printout/ChequeTemplate.vue";
	import Multiselect from "vue-multiselect";
	import RepaymentFilter from "./RepaymentFilter.vue";
	import ChatBot from "@/views/components/AI/ChatBot.vue";

	export default {
		components: {
			Multiselect,
			SidebarView,
			TopbarView,
			Footer,
			CashDeposit,
			CashWithdrawal,
			ChequeDeposit,
			ChequeWithdrawal,
			MomoDeposit,
			MomoWithdrawal,
			DirectDebitDeposit,
			DirectDebitWithdrawal,
			ChequePrintout,
			ChequeTemplate,
			RepaymentFilter,
			ChatBot,
		},
		data() {
			return {
				...this.initialState(),
				sources: [
					{ name: "USSD", id: "ussd" },
					{ name: "OFFICE", id: "office" },
					{ name: "MOBILE", id: "mobile" },
				],
				fields: [
					{
						label: "Reference",
						key: "code",
					},
					{
						label: "Loan Number",
						key: "loan_number",
					},
					{
						label: "Phone number",
						key: "customer.mobile",
					},
					{
						label: "Full name",
						key: "customer",
					},
					{
						label: "Amount",
						key: "trans_amount",
					},
					{
						label: "Interest",
						key: "interest",
					},
					{
						label: "Principal",
						key: "principal",
					},
					{
						label: "Ext. Ref",
						key: "external_reference",
					},
					{
						label: "Status",
						key: "trans_status",
					},
					{
						label: "Date",
						key: "trans_date",
					},
					{
						label: "Source",
						key: "source",
					},
					{
						label: "User",
						key: "user",
					},
					{
						label: "Actions",
						key: "actions",
					},
				],
				rows: [],
				currentPage: 1,
				perPage: 10,
				per_page_options: ["10", "20", "50", "100"],
				per_page_selected: "10",
				isBusy: false,
			};
		},
		mounted() {
			this.getAccountDropdown();
			this.getInsistution();
			this.loadItems();
		},
		methods: {
			statusBadge(item) {
				if (item === "FAILED") {
					return "badge akkurate-gray";
				} else if (item === "REJECTED") {
					return "badge akkurate-gray-bg";
				} else if (item === "COMPLETED") {
					return "badge akkurate-green-bg";
				} else if (item === "PENDING") {
					return "badge akkurate-warning-bg";
				} else if (item === "REJECTED") {
					return "badge akkurate-danger-bg";
				} else if (item === "REVERSED") {
					return "badge akkurate-danger-bg";
				} else {
					return "badge akkurate-warning-bg";
				}
			},
			navigatePage(index) {
				this.isBusy = true;
				this.currentPage = index;
				this.loadItems();
			},
			selectPerPage(index) {
				this.perPage = index;
				this.loadItems();
			},
			rowClass() {
				return "custom-row-height";
			},

			// submitFormFilters() {
			//   //this.serverParams.page = 1;
			//   //currentPage
			//   this.updateParams({ page: 1 });
			//   this.loadTransactions();
			// },
			// updateParams(newProps) {
			//   //console.log("new parms", newProps)
			//   this.serverParams = Object.assign({}, this.serverParams, newProps);
			// },

			// onPageChange(params) {
			//   this.updateParams({ page: params.currentPage });
			//   this.loadTransactions();
			// },

			// onPerPageChange(params) {
			//   this.updateParams({ perPage: params.currentPerPage });
			//   this.loadTransactions();
			// },

			// onSortChange(params) {
			//   this.updateParams({
			//     sort: [
			//       {
			//         type: params.sortType,
			//         field: this.columns[params.columnIndex].field,
			//       },
			//     ],
			//   });
			//   this.loadTransactions();
			// },

			onColumnFilter(params) {
				this.updateParams(params);
				this.loadItems();
			},
			async getAccountDropdown() {
				await ApiService.get("/accounts/create/dropdown")
					.then((response) => {
						// console.log(response);
						this.form.branch_option = response.data.branches;
						this.form.acc_types_option =
							response.data.account_types;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			async getInsistution() {
				await ApiService.get("/settings/institution")
					.then((response) => {
						// console.log(response);
						this.institution = response.data.data;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			async loadItems(searchFilter = null) {
				this.isLoading = true;
				this.isBusy = true;
				// var branch_id = "";
				// var acc_id = "";
				// if (this.form.branch != null) {
				//   branch_id = this.form.branch.id;
				// }
				// if (this.form.acc_types != null) {
				//   acc_id = this.form.acc_types.id;
				// }

				// var source = null
				// if (this.form.source) {
				//   source = this.form.source["id"];
				// }
				let users = [];
				let branches = [];
				//Reduce Users Array Object For Filters
				users = this.form.users?.reduce((accumulator, currentValue) => {
					accumulator.push(currentValue.id);
					return accumulator;
				}, []);
				//Reduce Branch Array Object For Filters
				// branches = this.form.branch?.reduce((accumulator, currentValue) => {
				//   accumulator.push(currentValue.id);
				//   return accumulator;
				// }, []);

				// console.log(this.form.branch.id);

				this.$Progress.start();
				await ApiService.post("/loans/repayments/all", {
					page: this.currentPage,
					per_page: this.perPage,
					filter: this.form.search,
					branch_id: this.form?.branch?.id ?? "", //Eg. 1, 2, etc
					// "account_type_id": acc_id,
					statuses: this.form.status,
					start_date: this.form.start_date,
					end_date: this.form.end_date,
					// "users_ids": users,
				})
					.then((response) => {
						// console.log(response.data.data);
						this.rows = response.data.data;
						this.totalRecords = response.data.meta.total;
						// this.all_data = response.data.data;
						this.$Progress.finish();
						this.isBusy = false;
					})
					.catch((error) => {
						// console.log(error);
						this.isLoading = false;
						this.$Progress.fail();
						this.isBusy = false;
					})
					.finally(() => {
						this.isLoading = false;
						this.$Progress.finish();
						this.isBusy = false;
					});
			},
			filterTable() {
				this.loadItems();
			},
			initialState() {
				return {
					totalRecords: 0,
					showViewTransaction: false,
					searchFilter: "",
					form: {
						source: "",
						branch: "",
						branch_option: [],
						acc_types: "",
						acc_types_option: [],
						mobile: "",
						loan_number: "",
						start_date: "",
						end_date: "",
						status: "",
						code: "",
						external_reference: "",
						transaction_type: "",
						status_option: [
							"Active",
							"Inactive",
							"Dormant",
							"Closed",
						],
					},
					isLoading: true,
					isSaving: false,
					add_or_edit: "add",
					report_data: {},
					institution: {},
				};
			},

			reverseLoanRepaymt(trans) {
				swal.fire({
					title: "Reverse Loan Repayment",
					text: `Are you sure you want to reverse loan repayment transaction id ${trans.code}?`,
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Yes Reverse !!!",
					allowOutsideClick: true,
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
					},
				}).then((result) => {
					if (result.value) {
						//   window.location.reload();
						let url = "/loans/transactions/reverse";

						this.$Progress.start();
						ApiService.post(url, {
							code: trans.code,
							transaction_id: trans.id,
							source: "OFFICE",
						})
							.then((respp) => {
								// console.log(respp);
								//this.isLoading = false;
								this.$Progress.finish();
								toast.fire({
									icon: "success",
									title: respp.data.message,
								});

								this.loadItems();
							})
							.catch((error) => {
								this.$Progress.fail();
							});
					}
				});
			},
			viewTransaction(trans) {
				// console.log("Veeeew");
				this.showViewTransaction = true;
			},
			getFullname(trans) {
				return `${trans.customer.first_name} ${trans.customer.last_name}`;
			},
			getCreatedAt(trans) {
				return this.removeAfterDot(trans.created_at);
			},
			approveWithdrawal(trans) {
				swal.fire({
					title: "Approve Withdrawal!",
					// title: "Successfull Saved",
					text: `Are you sure you want to approve withdrawal transaction ${trans.code}?`,
					// text: 'CODE : 14345664565',
					confirmButtonColor: "#018673",
					icon: "info",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				}).then(async (result) => {
					if (result.isConfirmed) {
						await ApiService.post(
							"/transactions/withdrawals/approve",
							{
								transaction_id: trans.id,
								code: trans.code,
							}
						)
							.then((respp) => {
								toast.fire({
									icon: "success",
									title: respp.data.message,
								});

								this.loadItems();
							})
							.catch((error) => {
								if (error.response.data.message) {
									toast.fire({
										icon: "error",
										title: error.response.data.message,
									});
								} else {
									toast.fire({
										icon: "error",
										title: "An error occurred",
									});
								}
							})
							.finally((resp) => {
								this.isLoading = false;
							});
					} else if (result.isDismissed) {
					}
				});
			},
			removeAfterDot(inputString) {
				if (inputString.includes(".")) {
					return inputString.split(".")[0];
				}
				return inputString; // If there's no dot, return the original string
			},
			// approveWithdrawal(data)
			// {
			//     swal.fire({
			//                     title: "Confirm Withdrawal Aproval",
			//                     // text: 'CODE : ' + response.data.transaction.code,
			//                     text: 'Are you sure you want to approve this withdrawal?',
			//                     confirmButtonColor: "#018673",
			//                     icon: 'question',
			//                     allowOutsideClick: false,
			//                     allowEscapeKey: false,
			//                     showCancelButton: true, // Show the "Cancel" button
			//                     confirmButtonText: 'Yes', // Customize the text for the "OK" button
			//                     cancelButtonText: 'No', // Text for the custom button
			//                     buttonsStyling: false, // Disable SweetAlert2 styling for buttons
			//                     customClass: {
			//                         confirmButton: 'btn btn-size akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
			//                         cancelButton: 'btn btn-size akkurate-ash modal-btn-width text-white' // Custom class for the custom button
			//                     }
			//                 }).then((result) => {
			//                     console.log(result)
			//                     // this.$Progress.start();
			//                     if (result.isConfirmed) {
			//                         this.isLoading = true;
			//                         // this.getAccountStatement();
			//                         // // this.isLoading = false;
			//                         // this.$Progress.finish();

			//                         this.loadTransactions();
			//                         // this.$bvModal.hide(String(this.loan_no + this.statement));
			//                     } else if (result.isDismissed) {
			//                         this.isLoading = false;
			//                         // this.$Progress.finish();

			//                     }
			//                 })
			// },
			rejectWithdrawal(data) {
				swal.fire(
					{
						title: "Confirm Withdrawal Rejection",
						// text: 'CODE : ' + response.data.transaction.code,
						text: "Are you sure you want to reject this withdrawal?",
						confirmButtonColor: "#018673",
						icon: "question",
						type: "input",
						allowOutsideClick: false,
						allowEscapeKey: false,
						showCancelButton: true, // Show the "Cancel" button
						confirmButtonText: "Yes", // Customize the text for the "OK" button
						cancelButtonText: "No", // Text for the custom button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
							cancelButton:
								"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
						},
					},
					function (inputValue) {
						if (inputValue === null) return false;

						if (inputValue === "") {
							// swal.showInputError("You need to write something!");
							return false;
						}

						// swal("Nice!", "You wrote: " + inputValue, "success");
					}
				).then((result) => {
					console.log("THEN");
					// this.$Progress.start();
					if (result.isConfirmed) {
						this.isLoading = true;
						// this.getAccountStatement();
						// // this.isLoading = false;
						// this.$Progress.finish();

						this.loadTransactions();
						// this.$bvModal.hide(String(this.loan_no + this.statement));
					} else if (result.isDismissed) {
						this.isLoading = false;
						// this.$Progress.finish();
					}
				});
			},
			printReceipt(data) {
				// console.log(data.item);
				this.report_data = {
					trans_date: data.trans_date,
					account_number: data.account?.account_number,
					fullname:
						data.customer?.first_name +
						" " +
						data.customer?.last_name,
					transaction_mode: data.transaction_mode,
					transaction_type: data.transaction_type,
					amount: data.trans_amount,
					cheque_no: "not avaliable",
					bank_name: "not avaliable",
					branch_name: data.branch,
					narration: data.narration,
					institution: this.institution,
					receipt_no: data.id,
					// teller: this.getTeller,
					denomination: data.denominations,
					mobile: data.mobile,
					network: data.network,
					external_reference: data.external_reference,
					momo_reference: data.momo_reference,
				};
				switch (data.transaction_mode) {
					case "Cash":
						if (data.transaction_type == "Deposit") {
							this.$refs.showCashDeposit.showModal();
							// console.log(this.form);
						} else if (data.transaction_type == "Withdrawal") {
							this.$refs.showCashWithdrawal.showModal();
						}

						break;
					case "Cheque":
						if (data.transaction_type == "Deposit") {
							this.$refs.showChequeDeposit.showModal();
							// console.log(this.form);
						} else if (data.transaction_type == "Withdrawal") {
							this.$refs.showChequeWithdrawal.showModal();
						}
						break;
					case "Momo":
						if (data.transaction_type == "Deposit") {
							this.$refs.showMomoDeposit.showModal();
							// console.log(this.form);
						} else if (data.transaction_type == "Withdrawal") {
							this.$refs.showMomoWithdrawal.showModal();
						}
						break;
					case "Direct Debit":
						if (data.transaction_type == "Deposit") {
							this.$refs.showDirectDebitDeposit.showModal();
							// console.log(this.form);
						} else if (data.transaction_type == "Withdrawal") {
							this.$refs.showDirectDebitWithdrawal.showModal();
						}
						break;
				}
			},
			reverseTransaction(trans) {
				swal.fire({
					title: "Reverse Transaction",
					text: `Are you sure you want to reverse repayment ${trans.code}?`,
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					allowOutsideClick: true,
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
					},
				}).then((result) => {
					if (result.value) {
						//   window.location.reload();

						this.$Progress.start();
						ApiService.post("loans/transactions/reverse", {
							transaction_id: trans.id,
						})
							.then((respp) => {
								// console.log(respp);
								//this.isLoading = false;
								this.$Progress.finish();
								toast.fire({
									icon: "success",
									title: respp.data.message,
								});

								this.loadItems();
							})
							.catch((error) => {
								this.$Progress.fail();
							});
					}
				});
			},
			chequePrintout(data) {
				this.report_data = {
					trans_date: data.trans_date,
					fullname:
						data.customer?.first_name +
						" " +
						data.customer?.last_name,
					amount: data.trans_amount,
					institution: this.institution,
				};
				this.$refs.showChequePrintout.showModal();
			},
			chequeTemplate(data) {
				this.report_data = {
					trans_date: data.trans_date,
					fullname:
						data.customer?.first_name +
						" " +
						data.customer?.last_name,
					amount: data.trans_amount,
					// institution: this.institution,
				};
				this.$refs.showChequeTemplate.showModal();
			},
		},
	};
</script>
